import { useTranslation } from 'react-i18next'

import { useGetGamesAppsQuery } from 'store/api/yay/games'

import { CategoriesGrid } from 'components/Categories'
import { InfiniteScrollList } from 'components/InfiniteScrollList/InfiniteScrollList'
import Modal from 'components/Modal/Modal'

import './style.scss'

export const SelectGameTitleModal = ({
  isActive,
  onClose,
  onSelect,
}: {
  isActive: boolean
  onClose: Function
  onSelect: Function
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      className="SelectGameTitleModal"
      isActive={isActive}
      onClose={onClose}
      title={t('common.game_title')}
    >
      <InfiniteScrollList
        query={{
          useQuery: useGetGamesAppsQuery,
        }}
      >
        {({ list }) => (
          <CategoriesGrid
            categories={list}
            onClick={(game) => {
              onSelect(game)
            }}
          />
        )}
      </InfiniteScrollList>
    </Modal>
  )
}
